(() => {
  function isMobile() {
    return window.matchMedia("(max-width: 749px)").matches;
  }

  function findScrollableViewport(gallery) {
    // ENLUAZE: antes isto fazia querySelectorAll("*") e chamava getComputedStyle()
    // em CADA elemento da galeria — recálculo de estilo forçado, elemento por elemento.
    // Os containers roláveis do Horizon são conhecidos, então testamos só eles.
    const conhecidos = gallery.querySelectorAll(
      "slideshow-slides, .media-gallery__grid, .media-gallery__carousel, [data-media-gallery-viewport]"
    );

    for (const el of conhecidos) {
      if (el instanceof HTMLElement && el.scrollWidth > el.clientWidth + 2) return el;
    }

    // Fallback: só se o Horizon mudar as classes numa versão futura.
    for (const el of gallery.querySelectorAll("*")) {
      if (!(el instanceof HTMLElement)) continue;
      if (el.scrollWidth <= el.clientWidth + 2) continue; // barato primeiro
      const style = getComputedStyle(el);
      if (/auto|scroll/.test(style.overflowX) || /auto|scroll/.test(style.overflow)) return el;
    }

    return null;
  }

  function setupOneGallery(gallery) {
    if (!gallery || gallery.dataset.ezPdpArrowsInit === "1") return;

    const arrowsWrap = gallery.querySelector(".ez-pdp-mobile-arrows");
    if (!arrowsWrap) return;

    const prev = arrowsWrap.querySelector(".ez-pdp-arrow--prev");
    const next = arrowsWrap.querySelector(".ez-pdp-arrow--next");
    if (!prev || !next) return;

    const viewport = findScrollableViewport(gallery);
    if (!viewport) {
      // se não achou nada rolável, esconde as setas
      arrowsWrap.style.display = "none";
      return;
    }

    gallery.dataset.ezPdpArrowsInit = "1";

    const step = () => Math.max(1, viewport.clientWidth);

    function updateDisabled() {
      const max = viewport.scrollWidth - viewport.clientWidth;
      if (max <= 2) {
        arrowsWrap.style.display = "none";
        return;
      }
      arrowsWrap.style.display = "";

      const left = viewport.scrollLeft;
      const atStart = left <= 2;
      const atEnd = left >= max - 2;

      prev.disabled = atStart;
      next.disabled = atEnd;

      prev.classList.toggle("is-disabled", atStart);
      next.classList.toggle("is-disabled", atEnd);
    }

    prev.addEventListener("click", () => {
      viewport.scrollBy({ left: -step(), behavior: "smooth" });
    });

    next.addEventListener("click", () => {
      viewport.scrollBy({ left: step(), behavior: "smooth" });
    });

    viewport.addEventListener(
      "scroll",
      () => window.requestAnimationFrame(updateDisabled),
      { passive: true }
    );

    // ENLUAZE: resize com debounce. Antes rodava a cada pixel de redimensionamento
    // (e a cada giro de tela / abertura de teclado no celular).
    let resizeTimer = null;
    window.addEventListener("resize", () => {
      if (!isMobile()) return; // só nos importa mobile
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateDisabled, 150);
    });

    updateDisabled();
  }

  function init() {
    if (!isMobile()) return;

    // Horizon: o wrapper que você tem é <media-gallery class="... media-gallery--carousel ...">
    document
      .querySelectorAll("media-gallery.media-gallery--carousel")
      .forEach(setupOneGallery);
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);

  // ENLUAZE: o MutationObserver observava o documento inteiro e nunca era desligado.
  // Enquanto a galeria não estivesse pronta, QUALQUER mudança no DOM (drawer, menu,
  // app de terceiros) re-executava a busca acima. Agora ele desliga sozinho assim que
  // encontra a galeria, e desiste depois de 10s se a página não tiver galeria nenhuma.
  const mo = new MutationObserver(() => {
    init();
    if (document.querySelector('media-gallery[data-ez-pdp-arrows-init="1"]')) mo.disconnect();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener("load", () => setTimeout(() => mo.disconnect(), 5000));
  setTimeout(() => mo.disconnect(), 30000); // teto absoluto, para conexões muito lentas
})();
